import { getCurrentUserId } from "@/config/useAuth";
import { callAPI } from "./ApiCall";
import { getCacheKey, isCacheValid, getCache, setCache } from "./CacheService";

export function createService(baseEndpoint) {
  return {
    async get(path, params, options = {}) {
      const {
        cache = false,
        cacheDuration = 24 * 60 * 60 * 1000,
        forceUpdate = false,
        strict = true,
      } = options;

      const fullUrl = `${baseEndpoint}${path}`;
      const cacheKey = getCacheKey("GET", fullUrl, params);

      let userId = null;

      if (cache) {
        userId = getCurrentUserId();
      }

      if (cache && !forceUpdate) {
        const cached = getCache(cacheKey);
        if (cached && isCacheValid(cached, cacheDuration, userId)) {
          return cached.data;
        }
      }

      try {
        const data = await callAPI("GET", fullUrl, params);

        let resultData = [];

        if (data && Array.isArray(data.result)) {
          resultData = data.result;
        } else if (Array.isArray(data)) {
          resultData = data;
        }

        if (cache && resultData.length > 0) {
          setCache(cacheKey, resultData, { userId });
        }

        return resultData;
      } catch (err) {
        if (strict) throw err;
        console.log("Ran");

        return []; // fallback if strict is off
      }
    },

    getWithDateRange(path, startDate, endDate, options = {}, extraParams = {}) {
      let query = `start=${startDate}&end=${endDate}`;
      for (const [key, value] of Object.entries(extraParams)) {
        if (value !== undefined && value !== null && value !== "") {
          query += `&${key}=${encodeURIComponent(value)}`;
        }
      }
      // extraParams land in the URL, so the cache key (built from the full URL)
      // is naturally scoped per database.
      return this.get(`${path}?${query}`, null, options);
    },

    post(path, data) {
      return callAPI("POST", `${baseEndpoint}${path}`, data);
    },
    put(path, data) {
      return callAPI("PUT", `${baseEndpoint}${path}`, data);
    },
    patch(path, data) {
      return callAPI("PATCH", `${baseEndpoint}${path}`, data);
    },
    delete(path, data) {
      return callAPI("DELETE", `${baseEndpoint}${path}`, data);
    },
  };
}

export async function mapServiceCall(serviceCall, mapper) {
  const data = await serviceCall;
  return mapper(data);
}
